import { render, staticRenderFns } from "./ShippingInstructions.vue?vue&type=template&id=0cd5b83e&scoped=true&"
import script from "./ShippingInstructions.vue?vue&type=script&lang=js&"
export * from "./ShippingInstructions.vue?vue&type=script&lang=js&"
import style0 from "./ShippingInstructions.vue?vue&type=style&index=0&id=0cd5b83e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd5b83e",
  null
  
)

component.options.__file = "ShippingInstructions.vue"
export default component.exports